<template>
  <info-box class="supplier-information" title="供应商配送信息" :show-line="false">
    <template slot="info">
      <div v-if="!isOrderDemoVersion" class="info">
        <div>
          供应商名称
          <p>{{ detail.carrierName || '--' }}</p>
        </div>
        <div>
          生产厂商
          <p>{{ detail.manufacturer || '--' }}</p>
        </div>
      </div>
      <a-table
      :columns="DRIVERCOLUMN"
      :data-source="driverList"
      :pagination="false"
      class="driver-list"
    >
    </a-table>
    </template>
  </info-box>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import InfoBox from './InfoBox.vue'

export default {
  name: 'SupplierInformation',
  components: {
    InfoBox,
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      DRIVERCOLUMN: [
        {
          title: '送达司机姓名',
          dataIndex: 'driverName',
          key: 'driverName',
          width: 120,
          customRender: (value) => value || '--'
        },
        {
          title: '送达司机手机号',
          dataIndex: 'driverPhone',
          key: 'driverPhone',
          width: 170,
          customRender: (value) => value || '--'
        },
        {
          title: '车牌号',
          dataIndex: 'licensePlate',
          key: 'licensePlate',
          width: 120,
          customRender: (value) => value || '--'
        },
        {
          title: '车型',
          dataIndex: 'carType',
          key: 'carType',
          width: 200,
          customRender: (value) => value || '--'
        },
        {
          title: '车辆预估送货时间段',
          dataIndex: 'timeRange',
          key: 'timeRange',
          width: 200,
          customRender: (value) => value || '--'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
    driverList() {
      const list = this.detail?.unifyWarehouseDriverInfoList;
      if (list.length > 0) {
        return list.map((t) => ({
          ...t,
          timeRange: t.predictDeliveryStartTime ? `${this.dealTime(t.predictDeliveryStartTime)} ~ ${this.dealTime(t.predictDeliveryEndTime)}` : '',
        }));
      }
      return [];
    }
  },
  methods: {
    dealTime(time){
      return moment(time).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style lang="less" scoped>
.supplier-information {
  padding: 32px 32px 0 30px;
  .info {
    font-size: 14px;
    line-height: 22px;
    color: #808792;
    display: flex;
    > div {
      margin-bottom: 16px;
      width: 320px;
    }
    p {
      color: #000F25;
    }
  }
  /deep/ .ant-descriptions {
    .ant-descriptions-row {
      .ant-descriptions-item-label, .ant-descriptions-item-content {
        padding: 0;
      }
    }
  }
}
</style>
